import { render, staticRenderFns } from "./DiscoveryTeaser.vue?vue&type=template&id=3e3dafb4"
import script from "./DiscoveryTeaser.vue?vue&type=script&lang=js"
export * from "./DiscoveryTeaser.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryTeaser.vue?vue&type=style&index=0&id=3e3dafb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports